import { render, staticRenderFns } from "./CateringBeo.vue?vue&type=template&id=a3b7888e&scoped=true"
import script from "./CateringBeo.vue?vue&type=script&lang=ts"
export * from "./CateringBeo.vue?vue&type=script&lang=ts"
import style0 from "./CateringBeo.vue?vue&type=style&index=0&id=a3b7888e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b7888e",
  null
  
)

export default component.exports